import { render, staticRenderFns } from "./ClientsListing.vue?vue&type=template&id=ad6ca9e8&"
import script from "./ClientsListing.vue?vue&type=script&lang=js&"
export * from "./ClientsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports